import styled from "styled-components";

const SupportIconStyles = styled.div`
  margin-bottom: 16px;
  background: #FFFFFF;
  cursor: pointer;

  .icon-container {
    display: flex;
    align-items: center;
    margin: auto;
    border: 1px solid rgba(18, 23, 36, 0.2);
    box-shadow: 0px 4px 24px rgba(229, 229, 229, 0.5);
    border-radius: 8px;
    width: 100%;
    height: 72px; 

    ${props => props.theme.media.lg} {
      flex-direction: column;
      height: auto;
    }

    .icon-image {
      margin: 16px;

      ${props => props.theme.media.lg} {
        margin-bottom: 8px;
      }
    }

    .icon-title {
      display: inline;
      font-family: 'Poppins';
      font-style: normal;
      font-weight: 500;
      font-size: 16px;
      line-height: 24px;
      letter-spacing: 0.01em;
      color: rgba(18, 23, 36, 0.91);

      ${props => props.theme.media.lg} {
        display: block;
        margin-bottom: 16px;
      }
    }
  }
`;

export default SupportIconStyles;